var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "w-list",
        [
          _vm._l(_vm.state.documents, function (doc) {
            return _c("app-aws-file-entry", {
              key: doc.ID,
              attrs: {
                doc: doc,
                documents: _vm.state.documents,
                edit: _vm.edit,
                "to-remove-docs": _vm.state.toRemoveDocs,
                uploading: _vm.state.uploading,
              },
            })
          }),
          _vm._l(_vm.state.toAddFiles, function (file, i) {
            return _c(
              "w-list-item",
              { key: i },
              [
                _c("w-list-item-text", [_vm._v(_vm._s(file.name))]),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("open-document"),
                                expression: "$ct('open-document')",
                              },
                            ],
                            attrs: { disabled: _vm.state.uploading },
                            on: {
                              click: function ($event) {
                                return _vm.openToAddFile(file)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "eye" } })],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("download-document"),
                                expression: "$ct('download-document')",
                              },
                            ],
                            attrs: { disabled: _vm.state.uploading },
                            on: {
                              click: function ($event) {
                                return _vm.downloadToAddFile(file)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "download" } })],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.edit
                      ? _c(
                          "w-list-item-action",
                          [
                            _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct("delete-document"),
                                    expression: "$ct('delete-document')",
                                  },
                                ],
                                staticClass: "danger",
                                attrs: { disabled: _vm.state.uploading },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteToAddFile(file)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "trash" } })],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _vm.edit
                    ? _c("app-upload-document", {
                        attrs: { uploading: _vm.state.uploading },
                        on: {
                          file: function ($event) {
                            return _vm.onFile($event)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }